import "./screen-size";
import "./navigation";
import "./table-of-contents";
import "./togglize";
import "SLICK/slick.js";
import '../lib/magnific-popup/jquery.magnific-popup';
import "./hero-video";
import "./banner";


(function ($) {
  $(document).ready(function () {
    console.log("starter theme...");

    function reduceAllMotion() {
      console.log("reducing motion...");
      $("video").prop("autoplay", false).siblings(".video-control-button-container").find(".video-control-button").attr("aria-label", "play");
    }

    /**
     * Flag Prefers Reduced Motion
     */
    const reducedMotionMediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!reducedMotionMediaQuery || reducedMotionMediaQuery.matches) {
      reduceAllMotion();
    }

    let $faqToggles = $(".faq-column").togglize({ action: "toggle", animate: true, animateSpeed: ".5s", firstOpen: false, adaptiveHeight: true });
    let $toggles = $(".togglize-me").togglize({ action: "toggle", animate: true, animateSpeed: ".5s", firstOpen: false });
    let $accordions = $(".accordionize-me").togglize({ action: "accordion", animate: true, animateSpeed: "0.75s" });
    // let twoCols = $(".two-col-content").twoColumnize();

    $(".testimonial-slider").slick({
      infinite: true,
      slidesToShow: 1,
      dots: true,
      arrows: false
    });
  

    /**
     * Copy Email Address to Clipboard
     */
    $("#team-member-list").on("click", ".email-copy-button", function (e) {
      let $emailButton = $(this);
      let email = $emailButton.data("email");
      navigator.clipboard.writeText(email).then(
        function copySuccess() {
          let emailButtonOriginalContent = $emailButton.html();
          $emailButton.text("Email Copied to Clipboard!");
          setTimeout(function resetToOldText() {
            $emailButton.html(emailButtonOriginalContent);
          }, 5000);
        },
        function copyFailed() {
          $emailButton.parent().append($(`<span>Your Browser Does Not Support the Clipboard</span><br><span class='fit-email'>${email}</span>`));
          $emailButton.remove();
        }
      );
    });

    // Magnific popup for floor plans
    $(".essen-lightbox-image").magnificPopup({
      type: "image",
      gallery: {
        enabled: true
      },
      image: {
        markup: '<div class="mfp-figure">' + '<div class="mfp-close"></div>' + '<div class="mfp-img"></div>' + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + '<div class="mfp-counter"></div>' + "</div>" + "</div>" // Popup HTML markup. `.mfp-img` di
      },
      verticalFit: true // Fits image in area vertically
    });

    $(".fp-lightbox-image").magnificPopup({
      type: "image",
      gallery:{
        enabled:false
      },
      closeOnContentClick: true
    });

  });
})(jQuery);
